import { Box, CircularProgress, Switch, SwitchProps } from '@mui/material'

function Icon({ color, loading = false }: { color?: SwitchProps['color']; loading?: boolean }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 20,
        height: 20,
        borderRadius: '50%',
        backgroundColor: loading ? (theme) => theme.palette.background.default : 'currentColor',
        boxShadow: 1,
      }}
    >
      {loading && <CircularProgress color={color === 'default' ? 'inherit' : color} size={14} thickness={5} />}
    </Box>
  )
}

type LoadingSwitchProps = SwitchProps & {
  loading?: boolean
}

export default function LoadingSwitch(props: LoadingSwitchProps) {
  const { color, loading, ...rest } = props
  return <Switch checkedIcon={<Icon color={color} loading={loading} />} icon={<Icon color={color} loading={loading} />} {...rest} />
}
